// extracted by mini-css-extract-plugin
export default {"text":"styles_text__7erIb","table":"styles_table__XDRSq","table_header":"styles_table_header__395Km","icon":"styles_icon__yHO5J"};